module.exports = __webpack_public_path__ + "img/separator-breadcrumb.0e8fb3ef.svg";